import { DateTimePicker } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { Checkbox, FormControl, FormControlLabel, FormHelperText, Grid, InputLabel, MenuItem, Paper, Select, TextField, Typography } from "@mui/material";
import axios from "axios";
import { createForm } from "rc-form";
import * as React from "react";
import { Config } from "../../config/config";
import { Helpers } from "../../utils/helpers";
import { PopupMessage } from "../../utils/message";
import { TASKS } from "./constants";
import { TaskMessage } from "./types/message";
import {EndSeason} from "./types/endSesason";

interface Props {
    activeUser: any;
    activeEnv: any;
    classes: any;
    form: any;
    history: any;
}

interface State {
    tasks: any[];
    loaded: boolean;
    type: null;
}

class TaskWrapped extends React.Component<Props, State> {

    constructor(props) {
        super(props);

        this.state = {
            tasks: [],
            loaded: false,
            type: null,
        };

        document.title = Helpers.documentTitle("Tasks");
    }

    renderTypeForm() {
        switch (this.props.form.getFieldValue("task_type")) {
            case "update_user_meta":
                return null;
            case "send_system_message":
                return <TaskMessage {...this.props} createTask={(opts) => this.createTask(opts)}/>;
            case "season_end":
                return <EndSeason {...this.props} createTask={(opts) => this.createTask(opts)}/>;
            default:
                return null;
        }
    }

    async createTask(opts = {}) {
        this.props.form.validateFields(async (_error, value) => {
            try {
                await axios.post(`${Config.getInstance.apiUrl}/api/tasks/create`, {
                    ...value,
                    ...opts,
                }, {
                    headers: {
                        Authorization: Helpers.getSessionId(),
                    },
                });

                PopupMessage.success("Task successfully created");

                setTimeout(() => {
                    this.props.history.push("/tasks");
                }, 1000);
            } catch (e) {
                PopupMessage.error("Something went wrong! Error: " + e.message);
            }
        });
    }

    render() {
        const { getFieldDecorator, getFieldValue} = this.props.form;

        return (
            <div className="contentPadding">
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <Paper className="root" elevation={0} style={{ padding: "10px 15px" }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Typography variant="h6" gutterBottom>
                                    Create new task
                                </Typography>
                            </Grid>

                            <Grid item xs={12}>
                                <FormControl
                                    fullWidth={true}
                                    required={true}
                                    variant="outlined"
                                >
                                    <InputLabel id="task-type-label">Task type</InputLabel>

                                    {getFieldDecorator("task_type",
                                        {
                                            validateTrigger: "onBlur",
                                            rules: [{
                                                required: true,
                                                message: "Please enter title",
                                            }]
                                        },
                                    )(
                                        <Select
                                            labelId="task-type-label"
                                            id="task-type"
                                            label="Task type"
                                        >
                                            {TASKS.map(task => (
                                                <MenuItem value={task.key} key={task.key}>{task.label}</MenuItem>
                                            ))}
                                        </Select>
                                    )}
                                </FormControl>
                            </Grid>

                            <Grid item xs={6}>
                                    <FormControl
                                        fullWidth={true}
                                        variant="outlined"
                                    >
                                        {getFieldDecorator("start_date", {
                                            initialValue: null,
                                        })(
                                            <DateTimePicker
                                                label="Start date"
                                                renderInput={(params) => <TextField {...params} size="small"/>}
                                                ampm={false}
                                            />
                                        )}
                                        <FormHelperText>Leave blank if task should be applied immediately</FormHelperText>
                                    </FormControl>
                            </Grid>

                            <Grid item xs={6}>
                                <FormControl
                                    fullWidth={true}
                                    variant="outlined"
                                >
                                    {getFieldDecorator("expire_date", {
                                        initialValue: null,
                                    })(
                                        <DateTimePicker
                                            label="Expire date"
                                            renderInput={(params) => <TextField {...params} size="small"/>}
                                            ampm={false}
                                        />
                                    )}
                                    <FormHelperText>Leave blank if task should be active forever</FormHelperText>
                                </FormControl>
                            </Grid>

                            <Grid item xs={6}>
                                <FormControl
                                    fullWidth={true}
                                    variant="outlined"
                                    required={true}
                                >
                                    {getFieldDecorator("trigger_new_users")(
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    name="trigger_new_users"
                                                    color="primary"
                                                />
                                            }
                                            label="Trigger task for new users"
                                        />
                                    )}
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Paper>
                </LocalizationProvider>
                {getFieldValue("task_type") && this.renderTypeForm()}
            </div>
        );
    }
}

export const Task = createForm()(TaskWrapped);
